import { awaitCondition, maybe } from './util'

let isWindowLoaded = false
window.addEventListener(`load`, () => {
  setTimeout(() => {
    isWindowLoaded = true
  }, 2000)
})

export function shouldDeferResources() {
  return maybe(() => window.vslyDeferResources) === true
}

export async function deferAfterPageLoad(fn: () => any) {
  await awaitCondition(() => isWindowLoaded,
    1000, 10)
  fn()
  return Promise.resolve()
}

export async function awaitForAddEventListeners(targetFn: () => any = () => window, defer = false): Promise<void> {
  if (defer && shouldDeferResources()) {
    await awaitCondition(() => isWindowLoaded,
      1000, 10)
  } else {
    await awaitCondition(() => maybe(() => targetFn().addEventListener) !== undefined,
      10, 1000)
  }
  return Promise.resolve()
}

export async function awaitForRemoveEventListeners(targetFn: () => any = () => window): Promise<void> {
  await awaitCondition(() => maybe(() => targetFn().removeEventListener) !== undefined,
    100, 100)
  return Promise.resolve()
}

export function getCookieDomainInner(hostname: string) {
  return hostname.replace(`www.`, '').replace("checkout.", "")
}

export const getCookieDomain = () => {
  return getCookieDomainInner(document.location.hostname)
}
export const setCookie = (
  name: string,
  value: string,
  expire: number,
  domain: string,
  secure: boolean
) => {
  const expireString =
    expire === Infinity
      ? ' expires=Fri, 31 Dec 9999 23:59:59 GMT'
      : '; max-age=' + expire
  const cookie =
    encodeURIComponent(name) +
    '=' +
    value +
    '; path=/;' +
    expireString +
    (domain ? '; domain=' + domain : '') +
    (secure ? '; secure' : '')
  document.cookie = cookie
}

export const generateId = () =>
  Math.random()
    .toString(36)
    .substring(2, 12)

export const parseQuery = (qs?: string) => {
  const queryString = qs || window.location.search.substring(1)
  const query: Record<string, string> = {}
  const pairs = (queryString[0] === '?'
    ? queryString.substr(1)
    : queryString
  ).split('&')
  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i].split('=')
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '')
  }
  return query
}

export { awaitCondition, maybe }

export function createDebouncedFn<T extends Function>(f: (...x: any) => any, wait = 20) {
  let h = 0 as unknown as NodeJS.Timeout
  const callable = (...args: any) => {
    clearTimeout(h)
    h = setTimeout(() => f(...args), wait)
  }
  return <T>(<any>callable)
}

const HIDE_PREVIEW_BAR_IFRAME = "vsly-hide-theme-preview"
export const hidePreviewBarIframe = () => {
  maybe(async () => {
    await awaitCondition(() => !!document && !!document.head, 10, 2000)
    const head = document.head || document.getElementsByTagName('head')[0]
    const style = document.createElement('style')
    style.id = HIDE_PREVIEW_BAR_IFRAME
    style.appendChild(document.createTextNode('#preview-bar-iframe,#PBarNextFrameWrapper,#PBarNextFrame { display: none !important;}'))
    head.appendChild(style)
  })
}

const VSLY_CUSTOM_CTAGS = `vslyCustomCtags`
const VSLY_CTAGS = 'vslyCtags'

export const initializeCustomerTags = () => {
  maybe(() => {
    const ctags = window.loomi_ctx.ctags || [] // customer tags are passed via liquid theme or SPA integration

    if (ctags.length === 0) {
      window.loomi_ctx.ctags = JSON.parse(localStorage.getItem(VSLY_CTAGS) || '[]')
    } else {
      localStorage.setItem(VSLY_CTAGS, JSON.stringify(ctags))
    }

    mergeWithCustomCtags()
  })
}

/**
 * Custom tags can be pushed via custom js code through the editor, and can be used later in targeting
 * essentially this will allow to tag visually users
 */
export function mergeWithCustomCtags() {
  maybe(() => {
    const customTags = JSON.parse(localStorage.getItem(VSLY_CUSTOM_CTAGS) || '[]') as Array<string>
    if (customTags && customTags.length > 0) {
      window.loomi_ctx.ctags = [...(window.loomi_ctx.ctags || []), ...customTags]
    }
  })
}

export const now = () => {
  return new Date(Math.floor(Date.now() / 1000) * 1000)
}
